module.exports = __webpack_public_path__ + "static/foragencies-kv-d26dff68e014f651bfbfe4e7167b887b.jpg";